import React from 'react';

import CodeMirror from 'codemirror';

import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/html-hint';
import 'codemirror/addon/hint/xml-hint.js';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/htmlmixed/htmlmixed';

class SourceModeEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { html: '' };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.initEditor();
    this.listenForChanges();
    this.listenForMouseEvents();
  }

  componentWillUnmount() {
    this.codeMirrorInstance.off('change', this.onChange);
    this.codeMirrorInstance.off('mousedown', this.props.onMouseDown);
    window.removeEventListener('mouseup', this.props.onMouseUp);
    this.codeMirrorInstance.off('change', this.onChange);
  }

  onChange(codeMirror) {
    const html = codeMirror.getValue();

    if (html === this.state.html) { return; }

    this.setState({ html });

    this.props.onChange(html);
  }

  initEditor() {
    const codeMirrorOptions = {
      lineWrapping: true,
      theme: 'material',
      autofocus: true,
      mode: 'htmlmixed',
      extraKeys: {
        'Ctrl-Space': 'autocomplete',
        'Ctrl-S': this.props.onSave,
        'Cmd-S': this.props.onSave
      },
      matchBrackets: true,
      autoCloseBrackets: true,
      autoCloseTags: true,
      completeSingle: true,
      smartIndent: true,
      tabSize: 2
    };

    this.codeMirrorInstance = CodeMirror.fromTextArea(this.sourceEditorEl, codeMirrorOptions);
  }

  listenForChanges() {
    this.codeMirrorInstance.on('change', this.onChange);
  }

  listenForMouseEvents() {
    this.codeMirrorInstance.on('mousedown', this.props.onMouseDown);
    // Code mirror's mouse down event works, but the mouse up one doesn't
    //  so we bind to window instead.
    window.addEventListener('mouseup', this.props.onMouseUp);
  }

  render() {
    const styles = {
      height: '100%',
      width: '100%'
    };

    return (
      <textarea
        style={styles}
        ref={(el) => { this.sourceEditorEl = el; }}
        value={this.props.htmlSource}
        autoFocus='true'
        readOnly='true'
      />
    );
  }
}

SourceModeEditor.propTypes = {
  htmlSource: React.PropTypes.string,
  onChange: React.PropTypes.func,
  onSave: React.PropTypes.func,
  onMouseDown: React.PropTypes.func,
  onMouseUp: React.PropTypes.func,
};

export default SourceModeEditor;



// WEBPACK FOOTER //
// ./src/ui/inline-text/source-mode-components/source-mode-editor.jsx